import { render, staticRenderFns } from "./RouteEditView.vue?vue&type=template&id=fbd3fdee&scoped=true&"
import script from "./RouteEditView.vue?vue&type=script&lang=js&"
export * from "./RouteEditView.vue?vue&type=script&lang=js&"
import style0 from "./RouteEditView.vue?vue&type=style&index=0&id=fbd3fdee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbd3fdee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
